import * as React from 'react';

export interface TenantBrandProps {
  primaryColor?: string;   // hex #298FC2
  secondaryColor?: string; // hex #5DC36B
  children: React.ReactNode;
}

/** Convertit un hex en HSL (pour --brand-primary/secondary) */
function hexToHslString(hex: string): string {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16) / 255;
  const g = parseInt(clean.substring(2, 4), 16) / 255;
  const b = parseInt(clean.substring(4, 6), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/**
 * Applique dynamiquement les couleurs du tenant à ses enfants
 * via les CSS variables --brand-primary et --brand-secondary.
 *
 * Résout le problème "toutes les villes ont la même couleur" de l'audit UX v1.
 */
export function TenantBrand({ primaryColor, secondaryColor, children }: TenantBrandProps) {
  const style: React.CSSProperties = {};
  if (primaryColor) (style as any)['--brand-primary'] = hexToHslString(primaryColor);
  if (secondaryColor) (style as any)['--brand-secondary'] = hexToHslString(secondaryColor);
  return <div style={style}>{children}</div>;
}
